let stickyHeader = {
    init: function () {

        document.addEventListener("scroll", stickyHeader.stick);

    },
    stick: function (event) {

        let header = document.querySelector('header')
        let sticky = header.offsetTop;

        if (window.scrollY > sticky) {
            header.classList.add("sticky")
        } else {
            header.classList.remove("sticky");
        }
    }
}